import type { AsyncState } from "@react-hookz/web";
import React from "react";
import { useStore } from "zustand";

import { NotificationType, notificationStore } from "../../store/notification";

export const useAsyncErrorStatusNotification = (
    state: AsyncState<any>,
    ignoreExceptionTypes: string[] = [],
    overrideMessage?: { [key in string]: string },
    identifier?: string,
): void => {
    const [upsertNotification] = useStore(notificationStore, (state) => [
        state.upsertNotification,
    ]);
    React.useEffect(() => {
        if (
            state.error &&
            (ignoreExceptionTypes.length === 0 ||
                !ignoreExceptionTypes.includes(state.error.name))
        ) {
            console.error(state.error.stack);
            let errorMessage = state.error.message;
            if (overrideMessage && state.error.name in overrideMessage) {
                errorMessage = overrideMessage[state.error.name];
            }
            upsertNotification(
                errorMessage,
                NotificationType.ERROR,
                identifier,
            );
        }
    }, [state.status]);
};
